export const FETCH_TEMPLATE_CONTENT_REQUEST = "FETCH_TEMPLATE_CONTENT_REQUEST";
export const FETCH_TEMPLATE_CONTENT_SUCCESS = "FETCH_TEMPLATE_CONTENT_SUCCESS";
export const FETCH_TEMPLATE_CONTENT_FAILURE = "FETCH_TEMPLATE_CONTENT_FAILURE";
